import * as React from "react"
import type { SVGProps } from "react"
const SvgNone = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 22.71a10 10 0 0 1-3.9-.78 10 10 0 0 1-3.17-2.14 10 10 0 0 1-2.14-3.18 10 10 0 0 1-.79-3.9q0-2.07.79-3.9a10 10 0 0 1 2.13-3.17Q6.28 4.29 8.1 3.5a10 10 0 0 1 3.9-.79q2.07 0 3.9.8a10 10 0 0 1 3.18 2.13q1.34 1.35 2.13 3.18a10 10 0 0 1 .79 3.9 10 10 0 0 1-.79 3.9 10 10 0 0 1-2.14 3.17q-1.34 1.35-3.17 2.14a10 10 0 0 1-3.9.79Zm0-2q1.35 0 2.6-.43A8 8 0 0 0 16.9 19L5.7 7.81a8 8 0 0 0-1.26 2.3 8 8 0 0 0-.44 2.6q0 3.36 2.32 5.68A7.7 7.7 0 0 0 12 20.7m6.3-3.1a8 8 0 0 0 1.7-4.9q0-3.35-2.33-5.67A7.7 7.7 0 0 0 12 4.7q-1.35 0-2.6.44A8 8 0 0 0 7.1 6.4z" />
  </svg>
)
export default SvgNone
